export class StringHelpers {
    public static alphabets = 'abcdefghijklmnopqrstuvwxyz';

    public static isAlphabetic(char: string) : boolean {
        return StringHelpers.alphabets.indexOf(char.toLowerCase()) > -1;
    }

    public static newGuid(): string {
        const S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }

    public static replaceHTMLTag(value: string) {
        return value.replace(/<[^>]*>/g, '');
    }

    public static toCamelCase(origKey: string) {
        if (!origKey) {
            return '';
        }

        const newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        return newKey;
    }
}
